import React from 'react';
import { CTALink, GatsbyLinkProps } from '@components/CTALink';
import { Link } from 'gatsby';

export const CTAGatsbyLink = ({ children, ...restProps }: React.PropsWithChildren<Omit<GatsbyLinkProps, 'forwardedAs'>>) => {
  return (
    <CTALink forwardedAs={Link} {...restProps}>
      {children}
    </CTALink>
  );
};
